import React from 'react';
import { Menu } from 'antd';
import Icon from '../Icon';

import { StyledTrigger } from './StyledComponents';

type TriggerProps = {
  collapsed: boolean;
  isMobile: boolean;
};

const Trigger: React.FC<TriggerProps> = ({ collapsed, isMobile }) => (
    <StyledTrigger
      mode="inline"
      selectable={false}
      $collapsed={collapsed}
      $isMobile={isMobile}
    >
      <Menu.Item
        key="collapse"
        icon={<Icon type="arrowLeftDouble" width={12} />}
      >
        <span>Collapse Menu</span>
      </Menu.Item>
    </StyledTrigger>
  );

export default Trigger;
